import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { APP_CONFIG } from '@shared/config';
import { SubjectArea } from '@shared/models';
import { HttpErrorSkip } from 'src/app/interceptors/http-error/http-error-skip.model';
import { GenericAnalytic } from '../models/analytic.model';

@Injectable({ providedIn: 'root' })
export class TrackingService {
  private readonly http = inject(HttpClient);
  private readonly analyticsUrl = inject(APP_CONFIG).analyticsUrl;
  private readonly url: string;

  constructor() {
    this.url = `${this.analyticsUrl}/analytic`;
  }

  public addUsageTracking(analytic: GenericAnalytic): void {
    this.http
      .post<SubjectArea>(this.url, analytic, {
        withCredentials: true,
        headers: {
          [HttpErrorSkip.HEADER_KEY]: new HttpErrorSkip({
            skipStatusCodes: [HttpErrorSkip.ALL_STATUSES_CODE],
          }).parseToString(),
        },
      })
      .subscribe();
  }
}
